
export { useNCWalletRecovery } from "/home/runner/work/capsicum/capsicum/libs/features/nc-onboarding/web/src/hooks/recovery-kit/index.ts"